import { getWebInitTimestamp, isPerformanceAPISupported } from './util';
export function sendActualFMPEvent(slardarClient) {
    const duration = markMetric({
        performanceMarkPoint: "ActualFMP:end" /* PerfMarkers.ActualFMPEnd */,
        performanceMeasureName: "ActualFMP" /* PerfMeasurements.ActualFMP */,
    });
    slardarClient.callClient('sendCustomPerfMetric', {
        name: 'actual_fmp',
        value: duration,
    });
    return duration;
}
function markMetric(options) {
    if (!isPerformanceAPISupported())
        return Date.now() - getWebInitTimestamp();
    try {
        performance.mark(options.performanceMarkPoint);
        return performance.measure(options.performanceMeasureName, {}, options.performanceMarkPoint).duration;
    }
    catch (err) {
        return Date.now() - getWebInitTimestamp();
    }
}
export function sendCustomRequestEvent(requestName, startTime, endTime, slardarClient) {
    const duration = endTime - startTime;
    slardarClient.callClient('sendEvent', {
        name: 'ttapplugin_custom_request',
        metrics: {
            requestStart: startTime - getWebInitTimestamp(),
            requestEnd: endTime - getWebInitTimestamp(),
            duration,
        },
        categories: {
            requestName,
        },
    });
    return duration;
}
export function sendFirstScreenRequestEvent(firstScreenRequests, slardarClient) {
    if (firstScreenRequests.length === 0) {
        return;
    }
    const startTimes = firstScreenRequests.map((x) => x.startTime);
    const requestStart = Math.min(...startTimes) - getWebInitTimestamp();
    const endTimes = firstScreenRequests.map((x) => x.endTime);
    const requestEnd = Math.max(...endTimes) - getWebInitTimestamp();
    slardarClient.callClient('sendEvent', {
        name: 'ttapplugin_first_screen_request',
        metrics: {
            requestStart,
            requestEnd,
            duration: requestEnd - requestStart,
        },
    });
}
export function sendRenderStartEvent(slardarClient) {
    const duration = markMetric({
        performanceMarkPoint: "Render:start" /* PerfMarkers.RenderStart */,
        performanceMeasureName: "RenderStart" /* PerfMeasurements.RenderStart */,
    });
    slardarClient.callClient('sendCustomPerfMetric', {
        name: 'render_start',
        value: duration,
    });
    return duration;
}
export function sendRenderEndEvent(slardarClient) {
    const duration = markMetric({
        performanceMarkPoint: "Render:end" /* PerfMarkers.RenderEnd */,
        performanceMeasureName: "RenderEnd" /* PerfMeasurements.RenderEnd */,
    });
    slardarClient.callClient('sendCustomPerfMetric', {
        name: 'render_end',
        value: duration,
    });
    return duration;
}
//# sourceMappingURL=onDemandMetric.js.map